import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, ButtonGroup, Col, Form, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { BsArrowDown, BsDownload } from "react-icons/bs";
import { FaArchive, FaSearch } from "react-icons/fa";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";
import funcionalidades from "../../../context/AuthContext.funcionalidades";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import ButtonImagePermission from "../Button/ButtonImagePermission";
import TextSpinner from "../Spinner/TextSpinner";
import FileDownloader from "../Button/FileDownloader";
import useDocumentoParteServico from "../../../pages/OS/ParteServico/hooks/useDocumentoParteServico";
import useEncerrarParteServicoOs from "../../../pages/OS/ParteServico/hooks/useEncerrarParteServicoOs";
import useFormBuscaAvancada from "../../../pages/OS/ParteServico/hooks/useFormBuscaAvancada";
import useEncerrarDenunciaOs from "./hooks/useEncerrarDenunciaOs";
import constants from "../../../pages/Constants";

const documentoParteServico = { exibir: () => {} };

const exibirDocumento = (sqParteServico) => {
  documentoParteServico.exibir(sqParteServico);
};

const OrigemOsPaginatedView = ({
  columns: propsColumns,
  title,
  keyField,
  defaultSearch,
  defaultSearchPlaceholder,
  advancedParameters: propsAdvancedParameters,
  queryService,
  history,
  editRoute,
  expandComponent,
  pageSizeRows = 10,
}) => {
  const { formik } = useFormBuscaAvancada();
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(pageSizeRows);
  const [pageNumber, setPageNumber] = useState(1);
  const [inputSearchArgument, setInputSearchArgument] = useState("");
  const [searchParameters, setSearchParameters] = useState({});
  const [tipoDocumento, setTipoDocumento] = useState("");
  const [sequencial, setSequencial] = useState();
  const advancedParameters = propsAdvancedParameters;
  const columns = [...propsColumns];
  const { setDocParams } = useDocumentoParteServico();
  const { encerrarPsModal, verificaPs } = useEncerrarParteServicoOs({ formik });
  const { encerrarDenunciaModal, verificaDenuncia } = useEncerrarDenunciaOs({ formik });

  documentoParteServico.exibir = (sqParteServico) => {
    setDocParams({ sqParteServico });
  };

  const { request, isLoading, data, errors } = useApiClient();

  const { request: requestDownload, data: dataDownload, errors: errorDownload } = useApiClient();

  const downloadCell = (row) => (
    <>
      {row.documento && <FileDownloader binario={row.documento} tooltip="Visualizar Documento" />}

      {!row.documento && (
        <ButtonImagePermission
          permission={funcionalidades.spf.download}
          className="btn-lg text-success pa-0 p-0"
          buttonImage={<BsDownload size="16" color="#e37023" />}
          tooltipImage={`Visualizar Doc ${row.sequencial}`}
          onClick={() => exibirDocumento(row.sequencial)}
        />
      )}

      {/* Encerrar Parte de Serviço */}
      {advancedParameters.tipoOrigem === "P" && (
        <ButtonImagePermission
          permission={funcionalidades.parteServico.encerrar}
          className="btn pa-0 p-0 px-1"
          onClick={() => {
            verificaPs(row.sequencial);
          }}
          buttonImage={<FaArchive />}
          tooltipImage="Encerrar"
        />
      )}

      {/* Encerrar Denuncia */}
      {advancedParameters.tipoOrigem === "D" && (
        <ButtonImagePermission
          permission={funcionalidades.parteServico.encerrar}
          className="btn pa-0 p-0 px-1"
          onClick={() => {
            verificaDenuncia(row.sequencial);
          }}
          buttonImage={<FaArchive />}
          tooltipImage="Encerrar"
        />
      )}
    </>
  );

  useEffect(() => {
    let nomeDocumento;
    let file;
    let url;

    if (dataDownload) {
      if (tipoDocumento === "D") {
        nomeDocumento = `denuncia-${sequencial}.pdf`;
      } else if (tipoDocumento === "C") {
        nomeDocumento = `cobranca-${sequencial}.html`;
      } else if (tipoDocumento === "P") {
        nomeDocumento = `parte-servico-${sequencial}.pdf`;
      }
      if (tipoDocumento === "D" || tipoDocumento === "P") {
        file = new Blob([dataDownload], { type: "application/pdf" });
        url = URL.createObjectURL(file);
        window.open(url, "", "width=800,height=800").print();
      } else {
        file = new Blob([dataDownload], { type: "application/html" });
        saveAs(file, nomeDocumento);
      }
    }

    if (errorDownload) {
      toast.error(errorDownload.message);
    }
  }, [dataDownload, errorDownload, sequencial, tipoDocumento]);

  const handleBaixarDocumento = useCallback(
    (sequencialDocumento, tipo) => {
      if (tipo === "D") {
        const params = { sqDenuncia: sequencialDocumento };
        requestDownload(apiRoutes.fiscalizacao.procedimentoFiscal.downloadDenuncia, params);
        setTipoDocumento(tipo);
        setSequencial(sequencialDocumento);
      } else if (tipo === "P") {
        const params = { sqParteServico: sequencialDocumento };
        requestDownload(apiRoutes.fiscalizacao.procedimentoFiscal.downloadParteServico, params);
        setTipoDocumento(tipo);
        setSequencial(sequencialDocumento);
      } else {
        const params = { sqCobranca: sequencialDocumento };
        requestDownload(apiRoutes.fiscalizacao.procedimentoFiscal.downloadCobranca, params);
        setTipoDocumento("C");
        setSequencial(sequencialDocumento);
      }
    },
    [requestDownload, setTipoDocumento, setSequencial],
  );

  const handlePageChange = useCallback((newPageNumber) => {
    setPageNumber(newPageNumber);
  }, []);

  const handlePerRowsChange = useCallback((newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(1);
  }, []);

  useEffect(() => {
    request(queryService, {
      ...advancedParameters,
      ...searchParameters,
      pageSize,
      pageNumber,
    });
  }, [request, queryService, advancedParameters, searchParameters, pageSize, pageNumber]);

  useEffect(() => {
    if (data && data.result) {
      if (data.result.length && !data.result[0].totalRows) {
        console.error(`[DEV] A propriedade "totalRows" é obrigatória nos resultados paginados. `);
        return;
      }
      setRows(data.result || []);
      setTotalRows(data.result.length ? data.result[0].totalRows : 0);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors]);

  // Download de pdf
  columns.push({
    name: "Ações",
    cell: (row) => downloadCell(row, advancedParameters.tipoOrigem, handleBaixarDocumento),
    maxWidth: "5%",
    center: true,
  });

  return (
    <>
      {encerrarPsModal}
      {encerrarDenunciaModal}
      <div className="row">
        <div className="col-lg-12">
          <div className="card shadow mb-4">
            {defaultSearch && (
              <div className="card-header pt-3 pb-0 flex-row w-100">
                <Form.Group as={Row} className="d-flex flex-row">
                  <Col sm="12" className="form-inline justify-content-end">
                    <h6 className="font-weight-bold text-primary flex-grow-1 ml-2 mt-2">{`A partir de ${title}`}</h6>
                    <ButtonGroup>
                      <Form.Control
                        className="w-auto border-top-right-0 border-bottom-right-0"
                        type="text"
                        placeholder={defaultSearchPlaceholder}
                        value={inputSearchArgument}
                        onChange={(e) => setInputSearchArgument(e.target.value)}
                      />
                      <Button
                        className="btn-search-inside btn-md mr-3"
                        onClick={() => {
                          setPageNumber(1);
                          setSearchParameters({ searchArgument: inputSearchArgument });
                        }}
                      >
                        <FaSearch />
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Form.Group>
              </div>
            )}
            <div className="card-body">
              <DataTable
                noHeader
                keyField={keyField}
                columns={columns}
                data={rows}
                progressPending={isLoading}
                noDataComponent="Nenhum registro para exibir"
                progressComponent={<TextSpinner />}
                pagination
                paginationComponentOptions={constants.paginationComponentOptions}
                sortable
                sortIcon={<BsArrowDown />}
                paginationTotalRows={totalRows}
                selectableRows={false}
                pointerOnHover
                onRowClicked={(item) => {
                  history.push({
                    pathname: editRoute,
                    state: {
                      sequencialOrigem: item[keyField],
                      tipoOrigem: advancedParameters.tipoOrigem,
                      documento: item.inscricaoEstadual ? item.inscricaoEstadual : item.cpfCnpj,
                      row: item,
                    },
                  });
                }}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                paginationPerPage={pageSize}
                expandableRows={expandComponent}
                expandableRowsComponent={expandComponent}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

OrigemOsPaginatedView.propTypes = {
  keyField: PropTypes.string.isRequired,
  editRoute: PropTypes.string.isRequired,
};

export default OrigemOsPaginatedView;
